import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as MBST from 'mb-components';

interface RegisterPageProps {
  location?: any;
}

type FormData = {
  email: string;
  password: string;
};

const RegisterPage: React.FC<RegisterPageProps> = ({ location }) => {
  const { registerUser, loginUser } = MBST.useAuth0();
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const query = new URLSearchParams(location.search);

  const formDefaultValues: any = {
    email: query.get('email') || '',
    password: '',
  };

  const { register, handleSubmit, errors, triggerValidation } = useForm<
    FormData
  >({
    defaultValues: formDefaultValues,
  });

  const onSubmit = (data: any) => {
    registerUser(data, registerCallback);
  };

  const registerCallback = (err: any, resp: any) => {
    if (err) {
      console.log(err);
    } else if (resp) {
      if (window.parent) {
        window.parent.postMessage('register', '*');
      }
      loginUser(email, password, () => {
        if (query.get('redirect')) {
          window.location.href = query.get('redirect') || '';
        }
      });
    }
  };

  return (
    <>
      <MBST.Heading>Register</MBST.Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <MBST.Box margin={{ bottom: '2' }} direction={'column'}>
          <MBST.TextInput
            type={'text'}
            name={'email'}
            placeholder={'Email'}
            ref={register({
              required: 'This is required',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i,
                message: 'invalid email address',
              },
            })}
            onChange={async (e: any) => {
              setEmail(e.target.value);
            }}
          />
          <MBST.ErrorMessage error={errors.email} />
        </MBST.Box>
        <MBST.Box margin={{ bottom: '5' }} direction={'column'}>
          <MBST.TextInput
            type={'password'}
            name={'password'}
            placeholder={'Password'}
            ref={register({
              required: 'This is required',
              validate: {
                hasNumbers: (value) => /\d/.test(value),
                hasSmallCase: (value) => /[a-z]/.test(value),
                hasCapitalCase: (value) => /[A-Z]/.test(value),
                hasSpecialCharacters: (value) =>
                  // eslint-disable-next-line
                  /[ !@#$%^&£*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value),
                hasMultipleLetters: (value) => /^(?:(.)(?!\1\1))*$/.test(value),
                length: (value) => value.length > 8,
              },
            })}
            onChange={async (e: any) => {
              setPassword(e.target.value);
              triggerValidation('password');
            }}
          />
          <MBST.ErrorMessage error={errors.password} />
        </MBST.Box>
        <MBST.Box>
          <MBST.Button type={'submit'}>Register</MBST.Button>
        </MBST.Box>
      </form>
    </>
  );
};

export default RegisterPage;
